<template>
  <div class="d-flex align-items-end menu">
    <b-dropdown
      v-if="$mq !== 'xl'"
      right
      id="hamburger-menu"
      class="btn ml-auto dropdown-profile d-flex align-items-end"
    >
      <template slot="button-content">
        <div class="hamburger-menu-button float-right" ref="toggleHamburgerMenu"></div>
      </template>
      <b-dropdown-header class="dropdownheader-mobile d-flex d-lg-none justify-content-between">
        <div></div>
        <button type="button" class="close" aria-label="Close" @click="triggerToggle">
          <span aria-hidden="true">&times;</span>
        </button>
      </b-dropdown-header>
      <profile-menu></profile-menu>
    </b-dropdown>

    <div v-else class="d-flex align-items-end ml-auto">
      <profile-menu class="ml-3"></profile-menu>
    </div>
  </div>
</template>

<script>
import ProfileMenu from './ProfileMenu'

export default {
  name: 'HamburgerMenu',
  components: {
    ProfileMenu,
  },
  methods: {
    triggerToggle() {
      this.$refs.toggleHamburgerMenu.click()
    },
  },
}
</script>
